import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useIntl } from 'react-intl-next';
import ArrowUpRightOpenIcon from '@atlaskit/icon/core/migration/arrow-up-right--open';
import Link from '@atlaskit/link';
import { B400 } from '@atlaskit/theme/colors';
import { AiBrand } from '../../../../../constants';
import { messages } from '../../../../../messages';
import { useAIAnswerContext } from '../../../../ai-answer-context';
import { onWhoPrimaryViewProfileClick, onWhoPrimaryViewProfileContextMenuClick } from '../../../../analytics';
import { ProfileSectionPrimaryUserHeader, ProfileSectionPrimaryUserImg, ProfileSectionPrimaryUserInfoTextWrapper, ProfileSectionPrimaryUserInfoWrapper, ProfileSectionPrimaryUserName, ProfileSectionPrimaryUserWrapper, ProfileSectionPrimaryViewProfileLinkWrapper, ProfileSectionPrimaryWrapper } from './styled';
import { ProfileSectionUserInfo, UserInfoTypeFormat } from './user-info';
export var ProfileSection = function ProfileSection(_ref) {
  var accountId = _ref.accountId,
    name = _ref.name,
    email = _ref.email,
    avatarUrl = _ref.avatarUrl,
    profileUrl = _ref.profileUrl,
    jobTitle = _ref.jobTitle,
    department = _ref.department,
    location = _ref.location,
    time = _ref.time;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    fireAnalyticsEvent = _useAIAnswerContext.fireAnalyticsEvent,
    onNavigate = _useAIAnswerContext.onNavigate;
  var profileLink = commonAttributes.brand === AiBrand.AI ? "/wiki/people/".concat(accountId) : profileUrl;
  return /*#__PURE__*/React.createElement(ProfileSectionPrimaryWrapper, null, /*#__PURE__*/React.createElement(ProfileSectionPrimaryUserWrapper, null, /*#__PURE__*/React.createElement(ProfileSectionPrimaryUserImg, {
    src: avatarUrl || '',
    alt: name
  }), /*#__PURE__*/React.createElement(ProfileSectionPrimaryUserInfoWrapper, null, /*#__PURE__*/React.createElement(ProfileSectionPrimaryUserHeader, null, /*#__PURE__*/React.createElement(ProfileSectionPrimaryUserName, null, name), /*#__PURE__*/React.createElement(ProfileSectionPrimaryViewProfileLinkWrapper, null, /*#__PURE__*/React.createElement(ArrowUpRightOpenIcon, {
    spacing: "spacious",
    label: "",
    color: "var(--ds-text-accent-blue, ".concat(B400, ")")
  }), /*#__PURE__*/React.createElement(Link, {
    href: profileLink || '',
    onClick: function onClick(event) {
      onNavigate(event);
      fireAnalyticsEvent(onWhoPrimaryViewProfileClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        primaryUserName: name
      })));
    },
    onContextMenu: function onContextMenu(event) {
      onNavigate(event);
      fireAnalyticsEvent(onWhoPrimaryViewProfileContextMenuClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        primaryUserName: name
      })));
    }
  }, formatMessage(messages.ai_answer_who_questions_view_profile)))), (jobTitle || department) && /*#__PURE__*/React.createElement(ProfileSectionPrimaryUserInfoTextWrapper, null, /*#__PURE__*/React.createElement(ProfileSectionUserInfo, {
    userInfo: jobTitle || '',
    userInfoType: UserInfoTypeFormat.JOBTITLE
  }), /*#__PURE__*/React.createElement(ProfileSectionUserInfo, {
    userInfo: department || '',
    userInfoType: UserInfoTypeFormat.DEPARTMENT
  })), /*#__PURE__*/React.createElement(ProfileSectionPrimaryUserInfoTextWrapper, null, /*#__PURE__*/React.createElement(ProfileSectionUserInfo, {
    userInfo: location || '',
    userInfoType: UserInfoTypeFormat.LOCATION
  }), /*#__PURE__*/React.createElement(ProfileSectionUserInfo, {
    userInfo: time || '',
    userInfoType: UserInfoTypeFormat.TIME,
    applyAdditionalTopIconPadding: true
  }), /*#__PURE__*/React.createElement(ProfileSectionUserInfo, {
    userInfo: email || '',
    userInfoType: UserInfoTypeFormat.EMAIL,
    applyAdditionalTopIconPadding: true
  })))));
};